import { ErrorMessage, Field, Formik, useFormik, Form, } from "formik";
import FormikSelectField from "../../../shared/components/FormikSelectField";
import { useEffect, useState, useRef } from "react";
import { Card,Button,Collapse,  Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { NOTIFICATION_AUDITS, CREATENEW } from "../../../shared/constants/Constants";
import DefaultButton from "../../../shared/components/DefaultButton";
import { loadNotificationDataRequest, loadNotificationGetDataRequest , loadNotificationAuditGetDataRequest} from "../redux/Actions";
import ListView from "../../../shared/components/listview/ListView"
import Breadcrumbs from "../../../shared/components/Breadcrumbs"
import Modalpopup from "../../../shared/components/Modalpopup";


const NotificationAudits = () => {        
    const dispatch = useDispatch();
    let navigate = useNavigate();
    let {notification, notify, audit} = useSelector(state => state.notification);
    let [selectedRow, setSelectedRow] = useState({});
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewData, setPreviewData] = useState({});
    const [showPreviewButton, setShowPreviewButton] = useState(false);

   useEffect(() =>{
        dispatch(loadNotificationDataRequest());
    },[dispatch]);
   
    const messageTypeIcons = {
            info: "ℹ️",
            warning: "⚠️",
            success: "✅",
            error: "❌",
          };    

    const columnDefs = () => {
        const baseColumns = [
            {
                display_name: "Id",
                field: "id",
                type: "number",
                hide: true,
            },
            {
                display_name: "Acknowledgement Header",
                field: "ack_header",
                type: "text"
            },
            // {
            //     display_name: "Application",
            //     field: "application",
            //     type: "text"
            // },
            {
                display_name: "By Pass Count",
                field: "bypass_count",
                type: "text",
            },
            {
                display_name: "Employee Name",
                field: 'employee_name',
                type: "text",

            },
            {
                display_name: "Acknowledgement Status",
                field: 'status_str',
                type: "text",

            }
        ];

        // Add dynamic question columns if notification data exists
        if (audit?.question_headers) {
            if (audit.question_headers.q1) {
                baseColumns.push({
                    display_name: "Question 1",
                    field: 'question1_answer',
                    type: "text",
                    tooltip: audit.question_headers.q1
                });
            }
            if (audit.question_headers.q2) {
                baseColumns.push({
                    display_name: "Question 2",
                    field: 'question2_answer',
                    type: "text",
                    tooltip: audit.question_headers.q2
                });
            }
            if (audit.question_headers.q3) {
                baseColumns.push({
                    display_name: "Question 3",
                    field: 'question3_answer',
                    type: "text",
                    tooltip: audit.question_headers.q3
                });
            }
        }

        return baseColumns;
    }

    useEffect(() => {
        if (audit?.notification) {
          setShowPreviewButton(true);
        }
      }, [audit]);
    
    return (
  <>
    <Breadcrumbs children={[{ href: '/notification/response', label: NOTIFICATION_AUDITS }]} />

    <Row className="mb-3">
      <Col></Col>
      <Col>
          <select
            className="form-select"
            value={selectedRow?.id || ""}
            onChange={(e) => { const selected = notification?.data?.find(n => n.id === e.target.value);
                              setSelectedRow(selected || null);
                            }}
          >
            <option value="">Select Notification</option> {notification?.data?.map((n) => ( <option key={n.id} value={n.id}> {n.ack_header}</option> ))}
          </select>
      </Col>
      <Col className="d-flex gap-2">
          <DefaultButton
            buttonClass="default-btn-color"
            buttonTitle="Submit"
            actionBlock={() => {if (selectedRow?.id) {
                          dispatch(loadNotificationAuditGetDataRequest(selectedRow.id));
                        }
                        }}
          />

          {showPreviewButton && (
            <DefaultButton
                buttonClass="btn preview-btn-color"
                buttonTitle="Preview"
                actionBlock={() => {                  
                    setPreviewData({
                      header: audit?.notification?.ack_header,
                      content: audit?.notification?.ack_content,
                      ack_type: audit?.notification?.ack_type,   
                      application: audit?.notification?.application,
                      document_link: audit?.notification?.document_link,
                    });
                    setPreviewOpen(true);
                  }}
              />
              )}
        </Col>
      <Col></Col>
    </Row>
    <Row>
      <Card>
        <Card.Body>
          {audit?.data?.length > 0 ? (
          <ListView
            exportTitle="Notification Audits"
            columnNames={columnDefs()}
            rowData={audit.data.map(item => ({
              ...item,
              bypass_count: item.bypass_count ?? 0,
              question1_answer: item.answer_q1 || '-',
              question2_answer: item.answer_q2 || '-',
              question3_answer: item.answer_q3 || '-'
            }))}

          />
          ) : (
          <p className="text-center">No audit data found</p>
          )}
        </Card.Body>
      </Card>
    </Row>
    {/* Preview Model */}
    <Modalpopup show={previewOpen} handleClose={() => setPreviewOpen(false)} size="lg" title="Notification Preview"  style={{ backgroundColor: "#f5f5f5" }}>
            <h5 style={{fontWeight: "600", margin: 0, marginBottom: "12px", paddingLeft: "0px"  }} className="notification-heading">
                {previewData.ack_type && (
                  <span style={{ marginRight: 4 }}>
                    {messageTypeIcons?.[previewData.ack_type] || ""}
                  </span>
                )}
                {previewData.header}
              </h5>
              <hr style={{ margin: "8px 0", border: "0", height: "6px", backgroundColor: "#999" }} />
              {previewData.ack_type === "text" && (
                <div
                  className="notification-preview"
                  dangerouslySetInnerHTML={{ __html: previewData.content }}
                />
              )}

              {previewData.ack_type === "image" && previewData.content && (
                <img
                  className="notification-preview img"
                  src={previewData.content}
                  alt="Notification"
                  style={{ maxWidth: "100%" }}
                />
              )}

              {previewData.ack_type === "video" && previewData.content && (
                <video controls style={{ maxWidth: "100%" }}>
                  <source src={previewData.content} />
                  Your browser does not support the video tag.
                </video>
              )}
              {previewData.document_link && (
                  <div style={{ marginTop: "12px", marginLeft: "20px"}} className="notification-link">
                      <a href={previewData.document_link} target="_blank"rel="noopener noreferrer"  style={{ color: "#007bff", fontWeight: 500,fontStyle: "italic", textDecoration: "underline" }}>
                          Click Here
                      </a>
                    </div>
                )}


              <div className="text-end mt-2">
                <DefaultButton
                  buttonClass="default-btn-color"
                  buttonTitle="Close"
                  actionBlock={() => setPreviewOpen(false)}
                />
              </div>
            </Modalpopup>


  </>
);

}

export default NotificationAudits;
